module.exports = __webpack_public_path__ + "img/11.71bdd6ed.png";